import { useContext } from 'react';
import { VoiceContext } from '../contexts/chat-contexts';

export default function useVoice() {
  return useContext(VoiceContext);
}
